import React from "react";
import { OptimizelyProvider } from "@optimizely/react-sdk";
import { optimizelyClient } from "./optimizelyClient";
import { UserInfo } from "@optimizely/react-sdk/dist/utils";

interface CustomerAttributes {
  customerId: string;
}

interface Props {
  children: React.ReactNode;
  userId?: string;
  /**
   * A set of custom attributes that can be used for targeted delivery in optimizely (e.g. Customer ID)
   */
  customerAttributes?: Partial<CustomerAttributes>;
}

export const OptimizelyProviderWrapper = ({
  children,
  userId,
  customerAttributes,
}: Props) => {
  let userProps: UserInfo | undefined = undefined;
  if (userId) {
    userProps = { id: userId };
    if (customerAttributes) {
      userProps.attributes = { ...customerAttributes };
    }
  }

  return (
    <OptimizelyProvider
      optimizely={optimizelyClient}
      user={userProps}
    >
      {children}
    </OptimizelyProvider>
  );
};
